import { render, staticRenderFns } from "./CpvMainPanel.vue?vue&type=template&id=2e7862f0&scoped=true&"
import script from "./CpvMainPanel.vue?vue&type=script&lang=js&"
export * from "./CpvMainPanel.vue?vue&type=script&lang=js&"
import style0 from "./CpvMainPanel.vue?vue&type=style&index=0&id=2e7862f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7862f0",
  null
  
)

export default component.exports